import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IframeCategoryItem, RegExpHelper } from '@atlas-workspace/shared/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OptionsIframeService } from '../services/options-iframe.service';
import { delay, map, of, switchMap, take } from 'rxjs';


@Component({
  selector: 'atl-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareModalComponent implements OnInit {
  @HostListener('window:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent): void {
    event.preventDefault();
    this.confirm();
  }
  @Input() tokenLink = '';
  @Input() readonly tokenId!: string;
  @Input() readonly navRoute!: string;

  @Input() readonly selectionToken!: string;

  @Output() private readonly saveChanges = new EventEmitter<string>();

  public disableSaveButton = true;
  public form!: FormGroup;
  public isShowMessageBanner = false;
  readonly messageBannerText = 'Shared.Entity.Link_copied';

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly cdr: ChangeDetectorRef,
    private readonly fb: FormBuilder,
    private readonly optionsIframeService: OptionsIframeService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.generateTokenLink();
    this.cdr.markForCheck();
  }

  closeModal(): void {
    this.activeModal.close();
  }

    confirm(): void {
        if (this.form.invalid) {
            return;
        }
        this.saveChanges.emit(this.form?.get('email')?.value);
        this.closeModal();
    }

    public copyToClipBoard(): void {
        navigator.clipboard.writeText(this.tokenLink);
        this.isShowMessageBanner = true;

        const delayTime = 2000;
        of(true).pipe(delay(delayTime))
        .subscribe(() => {
            this.isShowMessageBanner = false;
            this.cdr.markForCheck();
        });
    }

  private generateTokenLink(): void {
    this.optionsIframeService.categoriesData$
      .pipe(
        take(1),
        map((res: IframeCategoryItem[]) =>
          res
            .flatMap((cat) => cat.products ?? [])
            .filter((product) => product)
            .map(({ layoutProductTypeId, id }) => ({
              layout_product_type_id: layoutProductTypeId,
              layout_product_type_item_id: id,
            })),
        ),
        switchMap((selectedItems) =>
          this.optionsIframeService.saveIframeSelectedItems(this.tokenId, '', selectedItems ?? [], this.selectionToken),
        ),
        take(1),
      )
      .subscribe((token: string) => {
        this.tokenLink = `${window.location.origin}${this.navRoute}?selection_token=${encodeURIComponent(token)}`;
        this.cdr.markForCheck();
      });
  }

  private initForm(): void {
    this.form = this.fb.group({
      email: new FormControl(null, [Validators.required, Validators.pattern(RegExpHelper.email)]),
    });
  }
}
